// extracted by mini-css-extract-plugin
export default {"container":"ap-z","brandName":"bp-z","productName":"cp-z","productNamePdpEnhancements":"dp-z","breakLongProductName":"ep-z"};